
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { toAgencyTabs, toHomeTab } from "~/transformers/NavTabsTransformer";

export default {
  name: "NavTabs",
  computed: {
    ...mapState("application", ["selectedInstance"]),
    ...mapGetters({
      mainNav: "application/getMainNav",
      agencyTabs: "application/getAgencyTabs",
      isInFederatedInstance: "application/isInFederatedInstance",
    }),
    homeTab() {
      const context = {
        isFederated: this.isInFederatedInstance,
        instanceId: this.selectedInstance?.instanceId,
      };
      return {
        ...toHomeTab(this.$route.path, context),
        label: this.$t("nav.tabs.homeLabel"),
      };
    },
    tabs() {
      return toAgencyTabs(this.agencyTabs, this.$route.path);
    },
  },
  methods: {
    ...mapActions({
      setSelectedAgency: "application/setSelectedAgency",
      resetSelectedAgency: "application/resetSelectedAgency",
      removeNavLink: "application/removeNavLink",
    }),
    ...mapMutations({
      resetSelectedInstance: "application/RESET_SELECTED_INSTANCE",
    }),
    /** Find the raw sublink (with its agency context) backing a tab id. */
    findSublink(id) {
      const container = this.mainNav.find((nav) => nav.sublinks);
      return (container?.sublinks ?? []).find((sublink) => sublink.link === id);
    },
    onClick(id) {
      // The federated home tab points to the parent instance, whose navlink is
      // added at the root level (`addFederatedNavLink`), not inside `sublinks`,
      // so `findSublink` can't back it. Clear both contexts and navigate back so
      // breadcrumb and data reset to the parent instance.
      if (id === this.homeTab.id && this.isInFederatedInstance) {
        this.resetSelectedInstance();
        this.resetSelectedAgency();
        if (this.$route.path !== id) this.$router.push(id);
        return;
      }
      const sublink = this.findSublink(id);
      if (sublink?.agency) this.setSelectedAgency(sublink.agency);
      if (this.$route.path !== id) this.$router.push(id);
    },
    onClose(id) {
      const index = this.mainNav.findIndex((nav) => nav.sublinks);
      if (index < 0) return;
      const subindex = this.mainNav[index].sublinks.findIndex((sublink) => sublink.link === id);
      if (subindex < 0) return;
      this.removeNavLink({ index, subindex });
    },
  },
};
